<template>
    <form
      autocomplete="off"
      data-vv-scope="stepContent3"
      @submit.prevent="next('stepContent3', 'dadosPagamento')"
    >
      <div class="row">
        <div class="col">
          <h4>Dependentes</h4>
        </div>
      </div>
      <hr />
      <div class="form-row">
        <div class="col text-right">
          <button
            @click="addDependente"
            name
            id
            class="btn btn-success"
            type="button"
            :disabled="payload.dependentes.length === payload.plano.qtdDependentes"
          >
            <i class="fa fa-plus"></i>
            Adicionar
            <b>{{payload.dependentes.length + 1}} de {{payload.plano.qtdDependentes}}</b>
          </button>
        </div>
      </div>
      <div class="form-row mt-2">
        <div class="col-5 card mr-2" v-for="(dependente, i) in payload.dependentes" :key="i">
          <b-button variant="danger" @click="removeDepedente(i)">
            <i class="fa fa-trash"></i> Remover
          </b-button>
          <h5 class="mt-2">Dependente {{i + 1}}</h5>
          <div
            class="form-group"
            :class="{'has-danger': errors.has(`stepContent3.dependenteNome${i}`)}"
          >
            <label for>Nome Completo</label>
            <input
              :name="`dependenteNome${i}`"
              :id="`dependenteNome${i}`"
              v-validate="'required'"
              v-model="dependente.name"
              type="text"
              class="form-control"
            />
            <div
              v-if="errors.has(`stepContent3.dependenteNome${i}`)"
              class="help-block form-text text-muted form-control-feedback"
            >{{errors.first(`stepContent3.dependenteNome${i}`)}}</div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div
                class="form-group"
                :class="{'has-danger': errors.has(`stepContent3.dependenteDtNascimento${i}`)}"
              >
                <label for>Data de Nascimento</label>
                <input
                  :name="`dependenteDtNascimento${i}`"
                  :id="`dependenteDtNascimento${i}`"
                  v-validate="'required|date_format:dd/MM/yyyy'"
                  v-mask="'##/##/####'"
                  v-model="dependente.dataNascimento"
                  class="form-control"
                  type="tel"
                />
                <div
                  v-if="errors.has(`stepContent3.dependenteDtNascimento${i}`)"
                  class="help-block form-text text-muted form-control-feedback"
                >{{errors.first(`stepContent3.dependenteDtNascimento${i}`)}}</div>
              </div>
            </div>
            <div class="col-sm-6">
              <div
                class="form-group"
                :class="{'has-danger': errors.has(`stepContent3.dependenteCPF${i}`)}"
              >
                <label for>CPF</label>
                <input
                  :name="`dependenteCPF${i}`"
                  :id="`dependenteCPF${i}`"
                  v-validate="'cpf'"
                  v-mask="'###.###.###-##'"
                  v-model="dependente.cpf"
                  class="form-control"
                  type="tel"
                />
                <div
                  v-if="errors.has(`stepContent3.dependenteCPF${i}`)"
                  class="help-block form-text text-muted form-control-feedback"
                >{{errors.first(`stepContent3.dependenteCPF${i}`)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-buttons-w text-right">
        <button class="btn btn-primary" type="button" @click.prevent="$store.dispatch('setStep', 'dadosEndereco')">Voltar</button>
        <button class="btn btn-primary" type="submit">Ir para pagamento</button>
      </div>
    </form>
</template>
<script>
import ufs from '@/utils/ufs';

export default {
    props: {
        payload: {
            type: Object,
            required: true
        }
    },
    computed: {
        step() {
            return this.$store.getters.step;
        },
        empresa() {
            return this.$store.getters.empresa;
        },
        ufs() {
          return ufs;
        }
    },
    methods: {
      addDependente() {
        if (this.payload.dependentes.length < this.payload.plano.qtdDependentes) {
            this.payload.dependentes.push({});
        }
      },
      removeDepedente(i) {
        this.payload.dependentes.splice(i, 1);
      },
      next(from, to) {
        this.$validator.validateAll(from).then(result => {
            if (result) {
                this.$store.dispatch('setStep', to);
            }
        });
      }
    }
}
</script>